import { getWindowDocument } from '../windowUtils'

export const getExternalHeader = (className: string) => {
  const element = getWindowDocument()?.getElementsByClassName(className)[0]
  const height = element?.clientHeight || 0

  return {
    element,
    height,
  }
}
